import { render, staticRenderFns } from "./CobranzaForm.vue?vue&type=template&id=26df7b47&scoped=true"
import script from "./CobranzaForm.vue?vue&type=script&lang=js"
export * from "./CobranzaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26df7b47",
  null
  
)

export default component.exports